import *as _ from 'lodash'
import {ErrorMessage_restate} from "../PA.Core/Basic/MessageUtils";
import {GeneralLedgerBO} from "./GeneralLedgerBO";


export class GeneralLedgerBOValidations {

    static async ValidateFields(aBO: GeneralLedgerBO): Promise<void> {

        ErrorMessage_restate(aBO.ValidateMessageProvider,
            _.isEmpty((aBO.WB_GeneralLedger.cif.GENERAL_LEDGER_ID).trim()),
            "emptyID", "Id cannot be empty")

        ErrorMessage_restate(aBO.ValidateMessageProvider,
            _.isEmpty((aBO.WB_GeneralLedger.cif.GENERAL_LEDGER_NAME).trim()),
            "emptyName", "Name cannot be empty")
    }
}